import React, { useState, useEffect } from "react";
import RadioButton from "../../Fields/RadioButton";
import DropDownBox from "../../Fields/DropDownBox";
import { FaPlus, FaMinus } from "react-icons/fa";
import SelectBox from "../../Fields/SelectBox";
import TextInput from "../../Fields/TextInput"
import SelectedModification from "./SelectedModification";
import _, {} from "lodash";
import { Button } from "react-bootstrap";
import CMSearchService from "../../../services/CMSearchService";
import {BsFillQuestionCircleFill} from "react-icons/bs"; 
import { toast } from 'react-toastify';
import Tooltip from "@material-ui/core/Tooltip";
import GQPopup from "../GQPopups/GQPopup";
import GQInlinePopup from "../GQPopups/GQInlinePopup";
import { useSelector } from "react-redux";

const CMSearchPatterns = (props) =>{
    const toggle = useSelector(state => state.setToggle.toggle);
    const {formJson, setFormJson, hideTitle = false, hideTemplates = false, qSeqInstead = false, hideFormat = [], filtersKey = "cm_filters", title = "Search Patterns", centerTitle = false} = props
    const pfx = filtersKey + "_"
    
    const patternType=[ //not in Criteria
        {
            value: "EPR",
            label: "Exact Positions, Ranges"
        },
        {
            value: "FP",
            label: "Floating"
        },
        {
            value: "OC",
            label: "Occurrences"
        }
       
    ]

    const hiddenPatternTypeValues = Array.isArray(hideFormat)
        ? hideFormat
            .filter((value) => typeof value === "string")
            .map((value) => value.toUpperCase())
        : [];

    const filteredPatternType = patternType.filter(
        (type) => !hiddenPatternTypeValues.includes(type.value.toUpperCase())
    );

    const defaultPatternTypeValue = (filteredPatternType[0] || patternType[0]).value;

    //  const relationType =[ //not in Criteria yet
    //     {
    //         value: "RS",
    //         label: "Relative to the subject"
    //     },
    //     {
    //         value: "RQ",
    //         label: "Relative to the query"
    //     },
    //     {
    //         value: "RQS",
    //         label: "Relative to the query or the subject"
    //     },
       
    // ]

    const modType = [ //not in Criteria
        {
            value: "AMOD",
            label: "Any Modifications"
        },
        {
            value: "SMOD",
            label: "Any Selected Modification(s)"
        },
        {
            value: "OSMOD",
            label: "Only Selected Modification(s)"
        }
    ]

    const positionsMod = [
        {
            value: "anyOne",
            label: "<strong>Any of them</strong> found in, at least, at one of these positions",
            disabled: false,
        },
        {
            value: "anyAll",
            label: "<strong>Any of them</strong> found at each of these positions",
            disabled: false,
        },
        {
            value: "allOne",
            label: "<strong>All of them</strong> found in, at least, at one of these positions",
            disabled: false
        },
        {
            value: "allAll",
            label: "<strong>All of them</strong> Found at each of these positions",
            disabled: false
        },
        {
            value: "not",
            label: "<strong>None of them</strong> found at any of these positions",
            disabled: false
        },
    ]

    const occurrenceType = [
        {
            value: "EXACT",
            label: "Covering Exactly"
        },
        {
            value: "MIN",
            label: "Covering At Least"
        },
        {
            value: "MAX",
            label: "Covering Less Than"
        }
    ]

    const occurrenceMod = [
        {
            value: "NUM",
            label: "Position(s)",
        },
        {
            value: "PERC",
            label: "% of the sequence",
        }
    ]

    const erpSyntax = {
        title: "Exact Positions, Ranges Syntax",
        meaningTitle: "Meaning (using a 200 residue sequence)",
        syntax: [
            "Start",
            "End",
            //"5, 34",
            "First: 12",
            "Last: 25",
            "15..",
            "15..46",
            "12^45",
            "5..8^55..57",
            //"First:10, 12, 30..45, 60..65, Last: 20"
        ],
        meaning: [
            "Position 1",
            "Position 200",
            //"Positions 5 or 34",
            "Positions 1 to 12",
            "Positions 175 to 200",
            "Position 15 to the end of the sequence",
            "Positions 15 to 46",
            "Link between positions 12 and 45",
            "Link between a residue in positions 5 to 8 and a residue in positions 55 to 57",
            //"Positions 1 to 10, 12, 30 to 45, 60 to 65, or 181 to 200"
        ]

    }

    const fpSyntax = {
        title: "Floating Pattern Syntax",
        meaningTitle: "Meaning (relative to the reference modification)",
        syntax: [
            "5",
            "-14",
            "5, 34",
            "15..60",
            "-20..-15",
            "15..",
            "12^45",
            "5..8^55..57",
            "-10, 14^30, 60..65"
        ],
        meaning: [
            "Position 5",
            "Position -14 (negative position)",
            "Positions 5 or 34",
            "Positions 15 to 60",
            "Positions -20 to -15 (negative positions)",
            "Position 15 to the end of the sequence",
            "Link between positions 12 and 45",
            "Link between a residue in positions 5 to 8 and a residue in positions 55 to 57",
            "Positions -10, a link between position 14 and 30, or positions 60 to 65"
        ]

    }

    const [helpSyntax, setHelpSyntax] = useState({});
    const [helpIsOpen, setHelpIsOpen] = useState(false);  

    const [fpHelpIsOpen, setFpHelpIsOpen] = useState(false);

    const [helpLocation, setHelpLocation] = useState({top: 0, left: 0});
    
    function openHelp(helpId, type){
        setFpHelpIsOpen(false);
        let elm = document.getElementById(helpId);
        if(elm){
            let rect = elm.getBoundingClientRect();
            setHelpLocation({
                top: rect.top + window.scrollY,
                left: rect.left + window.scrollX
            });
            setHelpIsOpen(true);
        }

        if(type.toLowerCase() === "epr"){
            let helpSyntax = {...erpSyntax};
            setHelpSyntax({...helpSyntax});
        }else if(type.toLowerCase() === "fp"){
            let helpSyntax = {...fpSyntax};
            setHelpSyntax({...helpSyntax});
        }

        
    }

    function openFpHelp(helpId){
        setHelpIsOpen(false);
        let elm = document.getElementById(helpId);
        if(elm){
            let rect = elm.getBoundingClientRect();
            setHelpLocation({
                top: rect.top + window.scrollY,
                left: rect.left + window.scrollX
            });
            setFpHelpIsOpen(true);
        }
    }

    function closeHelp(){
        setHelpLocation({top: 0, left: 0});
        setHelpIsOpen(false);
        setFpHelpIsOpen(false);
    }

    function closeFpHelp(){
        setHelpLocation({top: 0, left: 0});
        setFpHelpIsOpen(false);
        setHelpIsOpen(false);
    }

    const configurePositions = (posMods, posistions) =>{
        let newPos = _.cloneDeep(posMods);
        for(let i = 0; i < posistions.length; i++){
            newPos[posistions[i]].disabled = true;
        }
        return newPos;
    }

    const configureModType = (patternType) =>{
        let newModType = _.cloneDeep(modType);
        if(patternType === "OC"){
            newModType[2].disabled = true;
        }else{
            newModType[2].disabled = false;
        }
        return newModType;
    }

    function unescapeThis(str) {
        return decodeURIComponent(str);
    }

    const floatingPositions = [
        {
            value: "ANY",
            label: "Anywhere in the sequence"
        },
        {
            value: "OVERLAP",
            label: "Overlap position or region"
        }
    ]

    const modAtom = {
        modType: modType[0].value, //not in output
        codes: [],
        type: positionsMod[0].value,
        posList: [{start: "1"}],
        posListStr: ""
    }

    const patternAtom = {
        cmCriteria: [_.cloneDeep(modAtom)],
        filterName: "",
        type: defaultPatternTypeValue,
        //relation: relationType[0].value,
        floatType: floatingPositions[0].value,
        // posList: [
        //     {start: "1"}
        // ],
        // posListStr: "1-end"
    }

    const [saveUI, setSaveUI] = useState(false);
    const [templateName, setTemplateName] = useState("");
    const [templateType, setTemplateType] = useState("");
    const [patternIndex, setPatternIndex] = useState(-1);
    const [isUpdateMode, setIsUpdateMode] = useState(false);
    const [updateModeOriginalName, setUpdateModeOriginalName] = useState("");

    const [confirmDeletePatternTemplateUI, setConfirmDeletePatternTemplateUI] = useState(false);
    const [renamePatternTemplateUI, setRenamePatternTemplateUI] = useState(false);
    const [renamePatternTemplateValue, setRenamePatternTemplateValue] = useState("");

    const [confirmDeletePatternUI, setConfirmDeletePatternUI] = useState(false);
    const [renamePatternUI, setRenamePatternUI] = useState(false);
    const [renamePatternValue, setRenamePatternValue] = useState("");
    const [actionPatternIndex, setActionPatternIndex] = useState(-1);
    const [actionSearchTemplateName, setActionSearchTemplateName] = useState("");
    const [actionPatternFilterName, setActionPatternFilterName] = useState("");

    const CustomErrorMsg = "Custom query is required and can only contain pattern references (P1, P2...), AND, OR, NOT, and parentheses. Please check for invalid sequences or unbalanced parentheses.";

    const closeSaveUI = () =>{
        setSaveUI(false);
        setTemplateName("");
        setTemplateType("");
        setPatternIndex(-1);
        setIsUpdateMode(false);
        setUpdateModeOriginalName("");
    }

    const openSaveUI = (type, prefillName = "", updateMode = false) =>{
        setTemplateType(type);
        setTemplateName(prefillName);
        setIsUpdateMode(updateMode);
        setUpdateModeOriginalName(prefillName);
        setSaveUI(true);
    }

    const handleDeletePatternTemplate = async () => {
        const name = actionSearchTemplateName;
        if (!name) return;
        const response = await CMSearchService.deletePatternTemplate(name);
        if (response !== undefined) {
            formJson.layout.search_preferences_patterns = (formJson.layout.search_preferences_patterns || []).filter(p => getTemplateEntryValue(p) !== name);
            if (formJson.searchInfo[filtersKey].template_name === name) {
                formJson.searchInfo[filtersKey].template_name = "";
            }
            setFormJson({...formJson});
            toast.success("Search pattern template deleted successfully");
        } else {
            toast.error("Error deleting search pattern template");
        }
        setConfirmDeletePatternTemplateUI(false);
        setActionSearchTemplateName("");
    };

    const handleRenamePatternTemplate = async () => {
        const oldName = actionSearchTemplateName;
        const newName = renamePatternTemplateValue.trim();
        if (!newName || !oldName || newName === oldName) {
            setRenamePatternTemplateUI(false);
            setActionSearchTemplateName("");
            return;
        }
        const existingTemplateNames = (formJson.layout.search_preferences_patterns || []).map(p => String(getTemplateEntryValue(p)));
        if (existingTemplateNames.includes(String(newName))) {
            toast.error("A search pattern template with this name already exists");
            return;
        }
        const loaded = await CMSearchService.getSavedPatternTemplate(oldName);
        const templateContent = loaded?.response_content?.map?.template;
        if (!templateContent) {
            toast.error("Error loading template for rename");
            return;
        }
        const saveData = {template_name: newName, template: templateContent};
        const saveResponse = await CMSearchService.savePatternTemplate(saveData);
        if (saveResponse !== undefined) {
            await CMSearchService.deletePatternTemplate(oldName);
            formJson.layout.search_preferences_patterns = (formJson.layout.search_preferences_patterns || []).map(p =>
                getTemplateEntryValue(p) === oldName ? newName : p
            );
            if (formJson.searchInfo[filtersKey].template_name === oldName) {
                formJson.searchInfo[filtersKey].template_name = newName;
            }
            setFormJson({...formJson});
            toast.success("Search pattern template renamed successfully");
        } else {
            toast.error("Error renaming search pattern template");
        }
        setRenamePatternTemplateUI(false);
        setRenamePatternTemplateValue("");
        setActionSearchTemplateName("");
    };

    const handleDeletePattern = async () => {
        const name = actionPatternFilterName;
        if (!name) return;
        const response = await CMSearchService.deletePattern(name);
        if (response !== undefined) {
            formJson.layout.search_preferences_pattern = (formJson.layout.search_preferences_pattern || []).filter(p => getTemplateEntryValue(p) !== name);
            if (actionPatternIndex >= 0 && formJson.searchInfo[filtersKey].patterns[actionPatternIndex]?.filterName === name) {
                formJson.searchInfo[filtersKey].patterns[actionPatternIndex].filterName = "";
            }
            setFormJson({...formJson});
            toast.success("Pattern template deleted successfully");
        } else {
            toast.error("Error deleting pattern template");
        }
        setConfirmDeletePatternUI(false);
        setActionPatternIndex(-1);
        setActionPatternFilterName("");
    };

    const handleRenamePattern = async () => {
        const index = actionPatternIndex;
        const oldName = actionPatternFilterName;
        const newName = renamePatternValue.trim();
        let oldDisplayName = oldName || "";
        if (oldDisplayName.startsWith("__")) {
            const parts = oldDisplayName.split("__");
            if (parts.length >= 3) oldDisplayName = parts[parts.length - 1];
        }
        if (!newName || !oldName || newName === oldDisplayName) {
            setRenamePatternUI(false);
            setActionPatternFilterName("");
            return;
        }
        const oldParts = oldName.split("__");
        const typePfx = oldParts.length >= 3 ? "__" + oldParts[1] + "__" : "";
        const newFullName = typePfx + newName;
        const existingValues = (formJson.layout.search_preferences_pattern || []).map(p => getTemplateEntryValue(p));
        if (existingValues.includes(newFullName)) {
            toast.error("A pattern template with this name already exists");
            return;
        }
        const loaded = await CMSearchService.getSavedPattern(oldName);
        const patternContent = loaded?.response_content?.map?.template;
        if (!patternContent) {
            toast.error("Error loading pattern for rename");
            return;
        }
        const saveData = {template_name: newFullName, template: patternContent};
        const saveResponse = await CMSearchService.savePattern(saveData);
        if (saveResponse !== undefined) {
            await CMSearchService.deletePattern(oldName);
            formJson.layout.search_preferences_pattern = (formJson.layout.search_preferences_pattern || []).map(p =>
                getTemplateEntryValue(p) === oldName ? newFullName : p
            );
            if (index >= 0 && formJson.searchInfo[filtersKey].patterns[index]?.filterName === oldName) {
                formJson.searchInfo[filtersKey].patterns[index].filterName = newFullName;
            }
            setFormJson({...formJson});
            toast.success("Pattern template renamed successfully");
        } else {
            toast.error("Error renaming pattern template");
        }
        setRenamePatternUI(false);
        setRenamePatternValue("");
        setActionPatternIndex(-1);
        setActionPatternFilterName("");
    };

    const getTemplateEntryValue = (templateEntry) => {
        if(typeof templateEntry === "string"){
            return templateEntry.trim();
        }

        if(templateEntry != null && typeof templateEntry === "object"){
            if(typeof templateEntry.value === "string"){
                return templateEntry.value.trim();
            }

            if(typeof templateEntry.label === "string"){
                return templateEntry.label.trim();
            }
        }

        if(templateEntry != null && typeof templateEntry !== "object"){
            return String(templateEntry);
        }

        return "";
    }

    const doesTemplateNameExist = () => {
        const currentTemplateName = templateName.trim();
        if(currentTemplateName === "" || formJson == null || formJson.layout == null){
            return false;
        }

        if(templateType === "Search Pattern"){
            const savedTemplates = Array.isArray(formJson.layout.search_preferences_patterns) ? formJson.layout.search_preferences_patterns : [];
            return savedTemplates.some(pref => String(getTemplateEntryValue(pref)) === String(currentTemplateName));
        }

        if(templateType === "Pattern"){
            const currentPatternType = formJson.searchInfo?.[filtersKey]?.patterns?.[patternIndex]?.type;
            if(typeof currentPatternType !== "string" || currentPatternType === ""){
                return false;
            }

            const fullPatternName = "__"+currentPatternType+"__"+currentTemplateName;
            const savedPatterns = Array.isArray(formJson.layout.search_preferences_pattern) ? formJson.layout.search_preferences_pattern : [];
            return savedPatterns.some(pref => String(getTemplateEntryValue(pref)) === String(fullPatternName));
        }

        return false;
    }

    const saveButtonLabel = doesTemplateNameExist() && templateType !== ""
        ? "Overwrite Existing template" : "Save as new";

    useEffect(()=>{
        if(formJson){
            let change = false;
            if(formJson.searchInfo == null || typeof formJson.searchInfo !== "object" || Array.isArray(formJson.searchInfo)){
                formJson.searchInfo = {};
                change = true;
            }

            if(formJson.layout == null || typeof formJson.layout !== "object" || Array.isArray(formJson.layout)){
                formJson.layout = {};
                change = true;
            }

            if(!Array.isArray(formJson.layout.errorIdList)){
                formJson.layout.errorIdList = [];
                change = true;
            }

            if(typeof formJson.layout.isRedo !== "boolean"){
                formJson.layout.isRedo = false;
                change = true;
            }

            if(formJson.searchInfo[filtersKey] === undefined){
                formJson.searchInfo[filtersKey] = {};
                change = true
            }else if(Array.isArray(formJson.searchInfo[filtersKey])){
                formJson.searchInfo[filtersKey] = {};
                change = true
            }else if(typeof formJson.searchInfo[filtersKey] === "string" && formJson.searchInfo[filtersKey].length >0){
                let cmFiltObj = JSON.parse(formJson.searchInfo[filtersKey]);

                if(cmFiltObj.template_name != null){
                    cmFiltObj.template_name = unescapeThis(cmFiltObj.template_name);
                }

                for(let j = 0; j < cmFiltObj.patterns.length; j++){

                    // cmFiltObj.patterns[j].type = "EPR";
                    // cmFiltObj.patterns[j].relation = "RS";
                    if(cmFiltObj.patterns[j].filterName != null){
                        cmFiltObj.patterns[j].filterName = unescapeThis(cmFiltObj.patterns[j].filterName);
                    }


                    for(let k = 0; k < cmFiltObj.patterns[j].cmCriteria.length; k++){
                        if(cmFiltObj.patterns[j].cmCriteria[k].modType == null){
                            if(cmFiltObj.patterns[j].cmCriteria[k].codes.length == 0){
                                cmFiltObj.patterns[j].cmCriteria[k].modType = "AMOD";
                            }else{
                                cmFiltObj.patterns[j].cmCriteria[k].modType = "SMOD";
                            }
                        }

                        if(cmFiltObj.patterns[j].type !== "OC"){
                            cmFiltObj.patterns[j].cmCriteria[k].posListStr = posListFromJson(cmFiltObj.patterns[j].cmCriteria[k].posList);
                        }else{
                            cmFiltObj.patterns[j].cmCriteria[k].countStr = cmFiltObj.patterns[j].cmCriteria[k].count+"";
                           
                        }
                    }
                }
                formJson.searchInfo[filtersKey] = cmFiltObj;
            }

            // if(Array.isArray(formJson.layout.search_preferences_pattern) || Array.isArray(formJson.layout.search_preferences_patterns)){
            //  formJson.layout.search_preferences_pattern = convertPatterns();
            //  formJson.layout.search_preferences_patterns = convertPatternsTemplates();
            //  change = true;    
            // }

            if(formJson.searchInfo[filtersKey].patterns == null){
                formJson.searchInfo[filtersKey].patterns = [_.cloneDeep(patternAtom)];
                formJson.searchInfo[filtersKey].mode = "AND";
                formJson.searchInfo[filtersKey].query = "";
                change = true
            }

            // if(formJson.layout.search_preferences_pattern != null){
            //     formJson.layout.search_preferences_pattern = convertPatterns();
            // }

            // if(formJson.layout.search_preferences_patterns != null){
            //     formJson.layout.search_preferences_patterns = convertPatternsTemplates();
            // }

            if(change){
                setFormJson({...formJson})
            }
        }
    },[formJson])

    const convertPatterns = () =>{
        let patterns = _.cloneDeep(formJson.layout.search_preferences_pattern);
        if(patterns != null && Array.isArray(patterns)){
            //sort alphabetically
            patterns.sort();

            //get first index of __EPR__
            let eprIndex = patterns.findIndex(p => typeof p === "string" && p.startsWith("__EPR__"));
            if(eprIndex > -1){
                let data = {label: "Exact Positions, Ranges", value: "eprnone", disabled: true, isCatagory: true};
                patterns.splice(eprIndex, 0, data);
            }

            //get first index of __FP__
            let fpIndex = patterns.findIndex(p => typeof p === "string" && p.startsWith("__FP__"));
            if(fpIndex > -1){
                let data = {label: "Floating Point", value: "fpnone", disabled: true, isCatagory: true};
                patterns.splice(fpIndex, 0, data);
            }
            //get first index of __OC__
            let ocIndex = patterns.findIndex(p => typeof p === "string" && p.startsWith("__OC__"));
            if(ocIndex > -1){
                let data = {label: "Occurence", value: "ocnone", disabled: true, isCatagory: true};
                patterns.splice(ocIndex, 0, data);
            }
            
            return patterns.map(pref => {
                //if pref is not an obj
                if(typeof pref !== "object"){
                    if(!pref || typeof pref !== "string" || pref == null) return {label: "~outdated~"+"", value: ""};

                    //find type by splitting __
                    let pType = "";
                    let name = pref;
                    //pattern names are stored as __TYPE__name
                    //extract TYPE
                    if(typeof pref === "string" && pref.startsWith("__")){ 
                        let parts = pref.split("__");
                        if(parts.length >= 3){
                            pType = parts[1];
                            name = parts[parts.length -1]; //in case name has __ in it
                        }
                    }

                    return {
                        type: pType,
                        label: name,
                        value: pref
                    };
                }else{
                    return pref;
                }
            });
        }

        return [];
    }

    const convertPatternsTemplates = () =>{

        if(formJson.layout.search_preferences_patterns != null){
            return formJson.layout.search_preferences_patterns.map(pref => {
                if(pref.value == null && pref.label == null){
                return {
                    label: String(pref),
                    value: String(pref)
                };
                } else {
                    return pref;
                }
            });
        }

        return [];
    }

    const switchCondition = (type) =>{
        formJson.searchInfo[filtersKey].mode = type;

        if(type === "CUSTOM"){
            const customQuery = (formJson.searchInfo[filtersKey].query || "").trim();
            if(customQuery === "" && !formJson.layout.errorIdList.includes(pfx + "customQuery")){
                formJson.layout.errorIdList.push(pfx + "customQuery");
            }
        }else{
            formJson.layout.errorIdList = formJson.layout.errorIdList.filter(id => id !== pfx + "customQuery");
        }

        setFormJson({...formJson})
    }

    const SaveTemplate = async() =>{
        const normalizedTemplateName = templateName.trim();

        if(normalizedTemplateName === ""){
            toast.error("Please enter a name for the template");
            return;
        }

        if(templateType === ""){
            toast.error("Please select a template type");
            return;
        }else if(templateType === "Search Pattern"){
            let data = {
                template_name: normalizedTemplateName,
                template: JSON.stringify(formJson.searchInfo[filtersKey])
            }
            let response = await CMSearchService.savePatternTemplate(data);
            if(response === ""){

                //add templatename to list
                const hasTemplate = Array.isArray(formJson.layout.search_preferences_patterns)
                    && formJson.layout.search_preferences_patterns.some(pref => String(getTemplateEntryValue(pref)) === String(normalizedTemplateName));
                if(!hasTemplate){
                    formJson.layout.search_preferences_patterns.push(normalizedTemplateName);
                }
                formJson.searchInfo[filtersKey].template_name = normalizedTemplateName;
                //formJson.layout.search_preferences_patterns = convertPatternsTemplates();
                setFormJson({...formJson});
                toast.success("Pattern template saved successfully");
                closeSaveUI();
            }else{
                toast.error("Error saving pattern template");
            }

        }else{
            let patternType = "__"+formJson.searchInfo[filtersKey].patterns[patternIndex].type+"__";
                let data = {
                template_name: patternType+normalizedTemplateName,
                template: JSON.stringify(formJson.searchInfo[filtersKey].patterns[patternIndex])
            }
            let response = await CMSearchService.savePattern(data);
            if(response == ""){
                const hasPattern = Array.isArray(formJson.layout.search_preferences_pattern)
                    && formJson.layout.search_preferences_pattern.some(pref => String(getTemplateEntryValue(pref)) === String(data.template_name));
                if(!hasPattern){
                    formJson.layout.search_preferences_pattern.push(data.template_name);
                }
                formJson.searchInfo[filtersKey].patterns[patternIndex].filterName = data.template_name;
                //formJson.layout.search_preferences_pattern = convertPatterns();
                setFormJson({...formJson});
                toast.success("Pattern saved successfully");
                closeSaveUI();
            }else{
                toast.error("Error saving pattern");
            }
        }
    }

    function posListToJson(modstr, type) {
     
        let retRay =[];
        if(type === "FP"){
            
            let newRay = modstr.split(",");
            for(let i = 0; i < newRay.length; i++){
                let obj = {};
                if(newRay[i].trim().includes("^")){
                    obj.linked = newRay[i].trim();
                }else if (newRay[i].trim().includes("..")) {
                    obj.regionStart = newRay[i].trim().split("..")[0].trim();
                    obj.regionEnd = newRay[i].trim().split("..")[1].trim();
                } else if(newRay[i].trim().includes("^")){
                    obj.linked = newRay[i].trim();
                } else {
                    obj = {region: newRay[i].trim()};
                }
                retRay.push(obj);
            }

        }else{
            
            let newRay = modstr.split(",");

            for(let i = 0; i < newRay.length; i++){
                
                let obj = {};
                let subStr = newRay[i].trim();
                const hasAlignmentStartToken = /(^|\W)start(\W|$)/i.test(subStr) || subStr.trim().startsWith("..");
                const hasAlignmentEndToken = /(^|\W)end(\W|$)/i.test(subStr);
                subStr = subStr.toLowerCase();
                subStr = subStr.replace("start", "1");

                if(subStr.startsWith("first:")) {
                    obj.first = subStr.replace("first:", "").trim();
                } else if(subStr.startsWith("last:")) {
                    obj.last = subStr.replace("last:", "").trim();
                } else if(subStr.includes("^")){
                    obj.linked = subStr;
                } else if(subStr.includes("..")) {
                    obj.start = subStr.split("..")[0].trim();
                    obj.end = subStr.split("..")[1].trim();
                    if(obj.end.includes("/")){
                        obj.end = obj.end.split("/")[0].trim();
                        obj.div = obj.end.split("/")[1].trim();
                    }
                    if(obj.end === "" || obj.end === "end"){
                        delete obj.end;
                    }
                    if(obj.start === ""){
                        obj.start = "1";
                    }
                }else{
                    if(subStr === "end"){
                        obj.last = "1";
                    }else{
                        obj.exact = subStr;
                    }
                }

                if(hasAlignmentStartToken || hasAlignmentEndToken){
                    obj.alignmentRelative = true;
                }

                retRay.push(obj);
            }
        }

        return retRay
    }

    function posListFromJson(posArray) {

        let modString = "";

        for(let i = 0; i < posArray.length; i++){
            
            let obj = posArray[i];
            let objKeys = Object.keys(obj);
            for(let j = 0; j < objKeys.length; j++){
                
                let subString = "";
                
                if(objKeys[j] === "start" || objKeys[j] === "regionStart"){
                    subString += obj[objKeys[j]]+"..";
                }else if(objKeys[j] === "end" || objKeys[j] === "regionEnd"){
                    subString += obj[objKeys[j]];
                }else if(objKeys[j] === "div"){
                    subString += "/"+obj.div;
                }else if(objKeys[j] === "last"){
                    subString += "last: "+obj.last;
                }else if(objKeys[j] === "first"){
                    subString += "first: "+obj.first;
                }else{
                    subString += obj[objKeys[j]];
                }

                modString += subString;

            }

            if(i< posArray.length -1){
                modString += ", ";
            }
        }
        
        return modString;
    }

    return(
        <>
        {formJson.searchInfo[filtersKey] != null && typeof formJson.searchInfo[filtersKey].patterns === "object" &&
        <div style={{width: "1000px"}}>
                <div
                    style={{
                        position: "absolute",
                        top: helpLocation.top,
                        left: helpLocation.left,
                        display: "flex",
                        flexDirection: "column-reverse",
                        alignItems: "flex-end"
                    }}
                >
                    <GQInlinePopup 
                        close={() => closeHelp()} 
                        show={helpIsOpen}
                        disabled = {formJson.layout.isRedo === true}
                        innerHtml={
                            <div style={{padding: "15px"}}>
                                <span style={{fontWeight: "bold", paddingBottom: "15px", display: "block"}}>{helpSyntax.title}</span>
                                <table>
                                    <thead>
                                        <tr >
                                            <th style={{textAlign: "left", padding:"5px 10px", borderRight: "1px solid #777", borderBottom: "1px solid #777"}}>Syntax</th>
                                            <th style={{textAlign: "left", padding:"5px 10px", borderBottom: "1px solid #777"}}>{helpSyntax.meaningTitle}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {helpSyntax.syntax && helpSyntax.syntax.map((syn, index) => (
                                            <tr key={index}>
                                                <td style={{fontSize: "10pt", textAlign: "left", padding: "5px 10px", verticalAlign: "top", borderRight: "1px solid #777"}}>{syn}</td>
                                                <td style={{fontSize: "10pt", textAlign: "left", padding: "5px 10px", verticalAlign: "top"}}>{helpSyntax.meaning != null && helpSyntax.meaning[index]}</td>
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>
                            </div>
                        }
                        
                    />
                    <GQInlinePopup 
                        close={() => closeFpHelp()} 
                        show={fpHelpIsOpen}
                        disabled = {formJson.layout.isRedo === true}
                        innerHtml={
                            <div style={{padding: "15px"}}>
                                <div>
                                <span style={{fontWeight: "bold", paddingBottom: "15px", display: "flex"}}>Floating Pattern - Overlap Position Region Syntax</span>
                                </div>
                                <div>
                                    <p style={{display: "flex", width: "400px"}}>Use this option to select the region in which you are searching for this pattern</p>

                                    <p style={{fontWeight: "bold"}}>Examples:</p>
                                    <p>First: 50</p>
                                    <p>Last: 20</p>
                                    <p>33..45</p>
                                </div>
                            </div>
                        }
                        
                    />
                </div>

            
            {!hideTitle && <p className="subHeading w-50 mb-10" style={{ margin: "10px 0" }}>{title}</p>}
            <div style={formJson.layout.isRedo === false ? {display: "flex", flexDirection: "column"} : {display: "flex", flexDirection: "column", borderRadius: "5px"}}>
            <div style={{display: "flex", flexDirection: "row", alignItems: "center", width: "100%", padding: "5px 5px"}} >
                <span style={{paddingRight: "25px", width: "fit-content", textWrapMode: "nowrap"}}>Results must meet:</span>
                <RadioButton
                    disabled={formJson.layout.isRedo === true}
                    checked = {formJson.searchInfo[filtersKey].mode === "AND"}
                    onChange={()=>{switchCondition("AND")}}
                />
                <span style={{paddingRight: "25px", width: "fit-content", textWrapMode: "nowrap"}}>all conditions</span>
                <RadioButton
                    disabled={formJson.layout.isRedo === true}
                    checked = {formJson.searchInfo[filtersKey].mode === "OR"}
                    onChange={()=>{switchCondition("OR")}}
                />
                <span style={{paddingRight: "25px", width: "fit-content", textWrapMode: "nowrap"}}>at least one condition</span>  

                <RadioButton
                    disabled={formJson.layout.isRedo === true}
                    checked = {formJson.searchInfo[filtersKey].mode === "CUSTOM"}
                    onChange={()=>{switchCondition("CUSTOM")}}
                />
                <span style={{paddingRight: "35px", width: "fit-content", textWrapMode: "nowrap"}}>custom</span>  
                <div style={{width: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "4px"}} hidden={hideTemplates}>
                <DropDownBox
                    disabled={formJson.layout.isRedo === true}
                    margin="normal"
                    variant="outlined"
                    label={"Search pattern templates"}
                    value={formJson.searchInfo[filtersKey].template_name != null ? formJson.searchInfo[filtersKey].template_name : ""}
                    onChange={(e)=>{
                        let val = e.target.value;
                        if(val !== ""){
                            CMSearchService.getSavedPatternTemplate(val).then((response)=>{
                                const val2 = response?.response_content?.map?.template;
                                if(!val2) return;
                                formJson.searchInfo[filtersKey] = JSON.parse(val2);
                                formJson.searchInfo[filtersKey].template_name = val;
                                setFormJson({...formJson});
                            });
                        }
                    }}
                    onEdit={formJson.layout.isRedo ? undefined : (val) => { setActionSearchTemplateName(val); setRenamePatternTemplateValue(val); setRenamePatternTemplateUI(true); }}
                    onDelete={formJson.layout.isRedo ? undefined : (val) => { setActionSearchTemplateName(val); setConfirmDeletePatternTemplateUI(true); }}
                    items={convertPatternsTemplates()}
                />
                </div>                
            </div>
            <div style={{width: "100%", padding: "5px", borderRadius: "8px"}} >
            {formJson.searchInfo[filtersKey].mode === "CUSTOM" &&    
                <div style={{width: "100%", paddingBottom: "10px"}} >
                    <style>{`
                        .custom-query-input .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
                            border-color: rgba(51, 122, 183, 0.5) !important;
                        }
                        .custom-query-input .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
                            border-color: #337ab7 !important;
                        }
                    `}</style>
                    <TextInput
                        className="custom-query-input"
                        disabled={formJson.layout.isRedo === true}
                        spellCheck="false"
                        id={pfx + "customQuery"}
                        variant="outlined"
                        type="text"
                        error={formJson.layout.errorIdList.includes(pfx + "customQuery")}
                        multiline={true}
                        fullWidth
                        value={formJson.searchInfo[filtersKey].query}
                        onChange={(e)=>{
                            //simple validation - only allow P1, P2... and AND, OR, NOT, and parentheses
                            let test = e.target.value.toUpperCase().trim();
                            let anyErrors = false;

                            if(test === ""){
                                anyErrors = true;
                            }

                            if(/[^P0-9ANDORNOT\(\)\s]/ig.test(test)){
                                anyErrors = true;
                            }

                            //check for invalid patterns like P followed by non-number
                            if(/P[^0-9]/g.test(test)){
                                anyErrors = true;
                            }

                            //check is number after p is greater than number of patterns
                            let patternCount = formJson.searchInfo[filtersKey].patterns.length;
                            let ps = test.match(/P[0-9]+/g) || [];

                            //if number after P is greater than pattern count, error
                            for(let i=0; i<ps.length; i++){
                                let num = parseInt(ps[i].substring(1)) - 1;
                                if(num > patternCount){
                                    anyErrors = true;
                                    break;
                                }
                            }

                            //check for invalid sequences of AND, OR, NOT
                            if(/(AND|OR|NOT){2,}/ig.test(test)){
                                anyErrors = true;
                            }

                            //check for AND or OR at beginning or end
                            if(/^(AND|OR)/.test(test) || /(AND|OR)$/.test(test)){
                                anyErrors = true;
                            }

                            //check for NOT at end
                            if(/NOT$/.test(test)){
                                anyErrors = true;
                            }

                            //check for empty parentheses or unbalanced parentheses
                            let openParens = (test.match(/\(/g) || []).length;
                            let closeParens = (test.match(/\)/g) || []).length;
                            if(/\(\s*\)/.test(test) || openParens !== closeParens){
                                anyErrors = true;
                            }

                            if(anyErrors){
                                if(!formJson.layout.errorIdList.includes(pfx + "customQuery")){
                                    formJson.layout.errorIdList.push(pfx + "customQuery")
                                }
                            }else{
                                //remove id from error list
                                const index = formJson.layout.errorIdList.indexOf(pfx + "customQuery");
                                if (index > -1) {
                                    formJson.layout.errorIdList.splice(index, 1);
                                }                            
                            }


                        formJson.searchInfo[filtersKey].query = e.target.value;
                        setFormJson({...formJson});
                        }}
                        label={"e.g. P1 AND (P2 OR P3) AND NOT P4"}
                        helperText={formJson.layout.errorIdList.includes(pfx + "customQuery") ? CustomErrorMsg : "" }
                    />
                </div>
            }
            {formJson.searchInfo[filtersKey] != null && formJson.searchInfo[filtersKey].patterns.length > 0 && formJson.searchInfo[filtersKey].patterns.map((pattern, index)=>{
                return(
            <div key={"patternContainer"+index}  style={{display: "flex", flexDirection: "column", border: "1px solid lightGrey", borderRadius: "8px", padding: "20px", marginBottom: "10px"}} >
                <div style={{display: "flex", width: "100%", justifyContent: "space-between"}}>
                    <div style={{display: "flex"}}>
                        {formJson.searchInfo[filtersKey].mode === "CUSTOM" &&
                        <div style={{paddingRight: "15px", marginTop: "12px", marginLeft: "-5px"}}>
                            <span style={{fontWeight: "bold", fontSize: "16px", color: "rgb(51, 122, 183)", padding: "10px", border: "1px solid rgb(51, 122, 183)", borderRadius: "5px"}}>P{index + 1}</span>
                        </div>
                        }
                        <div style={{paddingRight: "10px"}}>
                            <SelectBox
                                disabled={formJson.layout.isRedo === true}
                                margin="normal"
                                variant="outlined"
                                name="modType"
                                id="modType"
                                label="Choose Pattern Type"
                                value={pattern.type}
                                onChange={(e)=>{

                                    if(formJson.searchInfo[filtersKey].template_name != null){
                                        formJson.searchInfo[filtersKey].template_name = "";
                                    }
                                    pattern.filterName = "";

                                    let val = e.target.value;
                                    if(val === "OC"){
                                        for(let i=0; i<pattern.cmCriteria.length; i++){
                                            delete pattern.cmCriteria[i].posList;
                                            pattern.cmCriteria[i].type = occurrenceMod[0].value;
                                            pattern.cmCriteria[i].countType = occurrenceType[1].value;
                                            pattern.cmCriteria[i].count = 1;
                                            pattern.cmCriteria[i].countStr = "";
                                        }

                                    } else if(val === "FP"){
                                        for(let i=0; i<pattern.cmCriteria.length; i++){
                                            delete pattern.cmCriteria[i].countType;
                                            delete pattern.cmCriteria[i].count;
                                            delete pattern.cmCriteria[i].countStr;
                                            pattern.cmCriteria[i].type = positionsMod[0].value;
                                            if(i == 0){
                                                pattern.cmCriteria[i].posList = [{start: "1"}];
                                            }else{
                                                pattern.cmCriteria[i].posList = [{region: "1"}];
                                            }
                                        }
                                    }else{
                                        for(let i=0; i<pattern.cmCriteria.length; i++){
                                            delete pattern.cmCriteria[i].countType;
                                            delete pattern.cmCriteria[i].count;
                                            delete pattern.cmCriteria[i].countStr;
                                            pattern.cmCriteria[i].type = positionsMod[0].value;
                                            pattern.cmCriteria[i].posList = [{start: "1"}];

                                        }
                                    }
                                    pattern.type = val
                                    setFormJson({...formJson});
                                }}
                                items={filteredPatternType}
                            />
                        </div>
                        {/* <SelectBox
                            disabled={true || formJson.layout.isRedo === true}
                            margin="normal"
                            variant="outlined"
                            name="relationType"
                            id="relationType"
                            value={pattern.relation}
                            onChange={(e)=>{
                                pattern.relation = e.target.value;
                                setFormJson({...formJson});
                            }}
                            label="Choose Relation Type"
                            items={relationType}
                        /> */}
                        <div style={{paddingLeft:"5px", height: "44px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            {!qSeqInstead?<span>Relative to Subject</span>:<span>Relative to Query</span>}
                        </div>
                    </div>
                    <div hidden={hideTemplates}>
                        <DropDownBox
                            disabled={formJson.layout.isRedo === true}
                            margin="normal"
                            variant="outlined"
                            label={"Pattern templates"}
                            value={formJson.searchInfo[filtersKey].patterns[index].filterName != null ? formJson.searchInfo[filtersKey].patterns[index].filterName : ""}
                            onChange={(e)=>{
                                let val = e.target.value;
                                if(val !== ""){
                                    CMSearchService.getSavedPattern(val).then((response)=>{
                                        const val2 = response?.response_content?.map?.template;
                                        if(!val2) return;
                                        formJson.searchInfo[filtersKey].patterns[index] = JSON.parse(val2);
                                        formJson.searchInfo[filtersKey].patterns[index].filterName = val;
                                        setFormJson({...formJson});
                                    });
                                }
                            }}
                            onEdit={formJson.layout.isRedo ? undefined : (val) => {
                                let displayName = val;
                                if (val.startsWith("__")) {
                                    const parts = val.split("__");
                                    if (parts.length >= 3) displayName = parts[parts.length - 1];
                                }
                                setRenamePatternValue(displayName);
                                setActionPatternIndex(index);
                                setActionPatternFilterName(val);
                                setRenamePatternUI(true);
                            }}
                            onDelete={formJson.layout.isRedo ? undefined : (val) => {
                                setActionPatternIndex(index);
                                setActionPatternFilterName(val);
                                setConfirmDeletePatternUI(true);
                            }}
                            useCategories={true}
                            items={convertPatterns()}
                        />
                    </div>
                </div>
                {pattern.type === "FP" &&
                    <div style={{ paddingTop: "10px", display: "flex", width: "100%"}}>
                    <div style={{width: "200px"}}>
                    <SelectBox
                        disabled={formJson.layout.isRedo === true}
                        className="modTypeWidth"
                        margin="normal"
                        variant="outlined"
                        name="modType"
                        id="modType"
                        label="Choose Pattern Type"
                        value={pattern.floatType}
                        onChange={(e)=>{
                            let val = e.target.value;

                            if(val === "ANY"){
                                pattern.cmCriteria[0].posList = [{start: "1"}];
                            }

                            pattern.floatType = val;
                            setFormJson({...formJson});
                        }}
                        items={floatingPositions}
                    />
                    </div>
                    {pattern.floatType === "OVERLAP" &&
                    <div style={{paddingTop: "3px", paddingLeft: "22px"}}>
                        <div style={{width: "200px"}}>
                            <div
                                 style={{
                                     cursor: "pointer",
                                     position: "absolute",
                                     zIndex: "800",
                                     display: pattern.cmCriteria[0].posListStr === "" ? "flex" : "none",
                                     marginTop: "-1px",
                                     marginLeft: "185px",
                                     color: toggle ? "#008EC5" : undefined,
                                 }}
                            >
                                <BsFillQuestionCircleFill 
                                    id={"fpHelp"+index}
                                    onClick={() => {
                                        openFpHelp("fpHelp"+index);
                                    }}
                                />
                            </div>
                        <TextInput 
                            fullWidth
                            customClass={true}
                            error={formJson.layout.errorIdList.includes(pfx + "patternFP"+index)}
                            spellCheck="false"
                            id={pfx + "patternFP"+index}
                            label={"1..10"}
                            value={pattern.cmCriteria[0].posListStr}
                            onChange={(e)=>{

                                let val = e.target.value;
                                //pattern.posListStr = val;
                                //pattern.posList = posListToJson(val);
                                pattern.cmCriteria[0].posListStr = val;
                                pattern.cmCriteria[0].posList = posListToJson(val); 

                                let anyErrors = false;
                                val = val.trim();

                                if(val === ""){
                                    pattern.cmCriteria[0].posList = [{start: "1"}];
                                    formJson.layout.errorIdList = formJson.layout.errorIdList.filter(id => id !== pfx + "patternFP"+index);
                                    setFormJson({...formJson});
                                    return;
                                }

                                if(val !== ""){
                                    let match = val.match(/^((first:\s*\d+)|(last:\s*\d+)|(start\s*\.\.\s*end)|(start\s*\.\.\s*\d+)|(\d+\s*\.\.\s*end)|(\d+\s*\.\.\s*\d+)|(\.\.\d+)|(\d+\.\.)|(\d+\+)|(\d+\-))$/i);
                                    if(!match){
                                        anyErrors = true;
                                    }
                                }else{
                                    anyErrors = true;
                                }
                            
                                setFormJson({...formJson});
                                

                                if(anyErrors){
                                    // Handle errors
                                    if(!formJson.layout.errorIdList.includes(pfx + "patternFP"+index)){
                                        formJson.layout.errorIdList.push(pfx + "patternFP"+index);
                                        setFormJson({...formJson});
                                    }
                                }else{
                                    //remove id from error list
                                    formJson.layout.errorIdList = formJson.layout.errorIdList.filter(id => id !== pfx + "patternFP"+index);
                                    setFormJson({...formJson});
                                }
                            }}
                            variant="outlined"
                            disabled={formJson.layout.isRedo === true}
                        />
                        </div>
                    </div>
                }
                </div>
                }
                <div id="patternContainer" style={{display: "flex", flexDirection: "column", width: "100%", paddingTop: "20px"}}>
                    {pattern !== undefined && pattern.cmCriteria !== undefined && pattern.cmCriteria !== null &&
                    <>
                    {pattern.cmCriteria.length > 0 && pattern.cmCriteria.map((mod, index1)=>{
                        return(
                            <div key={"modIndex"+index1} style={{paddingBottom: "10px"}}>
                                {pattern.type !== "FP" && index1 > 0 &&
                                    <div style={{ paddingBottom: "5px"}}><strong>And</strong></div>
                                }
                               
                                <div style={{display: "flex", width: "100%", justifyContent: "space-between"}}>
                                    <div style={{display: "flex"}}>
                                        <div style={{width: "240px", paddingRight: "10px"}} className={"modType-wrapper-"+index1}>
                                            <style>{`
                                                .modType-wrapper-${index1} .MuiOutlinedInput-notchedOutline {
                                                    border-color: ${toggle ? 'none' : 'white'} !important;
                                                }
                                                .modType-wrapper-${index1}:hover .MuiOutlinedInput-notchedOutline {
                                                    border-color: ${toggle ? 'none' : 'white'} !important;
                                                }
                                                .modType-wrapper-${index1} .Mui-focused .MuiOutlinedInput-notchedOutline {
                                                    border-color: ${toggle ? 'none' : 'white'} !important;
                                                }
                                            `}</style>
                                            <SelectBox
                                                customClass={true}
                                                className="modTypeWidth"

                                                customMenuClass=""
                                                disabled={formJson.layout.isRedo === true}
                                                margin="normal"
                                                variant="outlined"
                                                id={"modType"+index1}
                                                key={"modType"+index1}
                                                label="Choose Modification Type"
                                                value={mod.modType}
                                                onChange={(e)=>{
                                                    mod.modType = e.target.value;
                                                    if(mod.modType === "AMOD"){

                                                        mod.codes = [];

                                                        if(formJson.layout.errorIdList.includes(pfx + "modCodes"+index+"-"+index1)){
                                                            //remove id from error list
                                                            formJson.layout.errorIdList = formJson.layout.errorIdList.filter(id => id !== pfx + "modCodes"+index+"-"+index1);   
                                                        }
                                                        
                                                        if(mod.type === "allOne" || mod.type === "allAll"){
                                                            mod.type = "all";
                                                        }
                                                    }

                                                    setFormJson({...formJson});
                                                }}
                                                items={configureModType(pattern.type)}
                                            />
                                        </div>
                                        {(pattern.type === "FP" && index1 === 0) &&
                                        <div  style={{padding: "0 10px", width: "550px", display: "flex", alignItems: "center"}}>
                                            <span>
                                                Consider the location of this modification as the anchor position and equal to 1 for the
                                                following relative positions
                                            </span>
                                        </div>
                                        }
                                        {!(pattern.type === "FP" && index1 === 0) && pattern.type !== "OC" && 
                                            <div style={{display: "flex"}}>
                                                <div style={{paddingRight: "5px", width: "410px"}} className={"modType-wrapper-"+index1}>
                                                <style>{`
                                                    .modType-wrapper-${index1} .MuiOutlinedInput-notchedOutline {
                                                        border-color: ${toggle ? 'none' : 'white'} !important;
                                                    }
                                                    .modType-wrapper-${index1}:hover .MuiOutlinedInput-notchedOutline {
                                                        border-color: ${toggle ? 'none' : 'white'} !important;
                                                    }
                                                    .modType-wrapper-${index1} .Mui-focused .MuiOutlinedInput-notchedOutline {
                                                        border-color: ${toggle ? 'none' : 'white'} !important;
                                                    }
                                                `}</style>
                                                    <SelectBox
                                                        customClass={true}
                                                        className="modTypeWidth"
                                                        disabled={formJson.layout.isRedo === true}
                                                        margin="normal"
                                                        variant="outlined"
                                                        name="relationType"
                                                        id={"relationType"+index1}                                                     
                                                        key={"relationType"+index1}
                                                        value={mod.type}
                                                        onChange={(e)=>{
                                                            mod.type = e.target.value;
                                                            setFormJson({...formJson});
                                                        }}
                                                        items={mod.modType === "AMOD" ? configurePositions(positionsMod, [2,3]) : pattern.type === "FP" ? configurePositions(positionsMod, [1]) : configurePositions(positionsMod, [])}
                                                        allowHtmlLabels
                                                    />
                                                </div>
                                                <div style={{paddingTop: "3px", width: "157px"}}>
                                                    <div>
                                                        <div
                                                            style={{
                                                                cursor: "pointer",
                                                                position: "absolute",
                                                                zIndex: "800",
                                                                display: mod.posListStr== "" ? "flex" : "none",
                                                                marginTop: "-1px",
                                                                marginLeft: "142px",
                                                                color: toggle ? "#008EC5" : undefined,

                                                            }}
                                                        >
                                                            <BsFillQuestionCircleFill 
                                                                id={"help"+index+"-"+index1}

                                                                onClick={() => {
                                                                    openHelp("help"+index+"-"+index1, pattern.type);
                                                                }}
                                                            />
                                                       </div>
                                                    <TextInput 
                                                        fullWidth
                                                        customClass={true}
                                                        disabled={formJson.layout.isRedo === true}
                                                        spellCheck="false"
                                                        id={pfx + "patternText"+index1}
                                                        key={"patternText"+index1}
                                                        label={pattern.type === "FP"? "1, -3..5":"First: 10, 3..15, end"}
                                                        value={mod.posListStr}
                                                        onChange={(e)=>{

                                                            let val = e.target.value;
                                                            mod.posListStr = val;
                                                            mod.posList = posListToJson(val, pattern.type);

                                                            if(val.trim() === ""){
                                                                mod.posList = [{start: "1"}];
                                                                formJson.layout.errorIdList = formJson.layout.errorIdList.filter(id => id !== pfx + "patternText"+index1);
                                                                setFormJson({...formJson});
                                                                return;
                                                            }
                                                            
                                                            let anyErrors = false;
                                                            if(pattern.type === "FP"){

                                                                if(val.trim() !== ""){  
                                                                    val = val.trim();
                                                                    let parts = val.split(",");

                                                                    for(let i=0; i<parts.length; i++){
                                                                        parts[i] = parts[i].trim();
                                                                        let match = parts[i].match(/^(\-?\d+(\.\.\-?\d+)?(\^\-?\d+)?(\.\.\-?\d+)?(\.\.)?)$/ig)
                                                                        if(!match){
                                                                            anyErrors = true;
                                                                        }
                                                                        if(parts[i].includes("^")){
                                                                            let subParts = parts[i].split("^");
                                                                            if(subParts.length === 2){
                                                                                let num1, num2;
                                                                                if(subParts[0].includes("..") && subParts[1].includes("..")){
                                                                                    let rangeParts = subParts[0].split("..");
                                                                                    let rangeParts2 = subParts[1].split("..");
                                                                                    num1 = rangeParts[0].trim().toLowerCase();
                                                                                    num2 = rangeParts2[0].trim().toLowerCase();
                                                                                }else{
                                                                                    num1 = subParts[0].trim().toLowerCase();
                                                                                    num2 = subParts[1].trim().toLowerCase();
                                                                                }

                                                                                if(parseInt(num1) >= parseInt(num2)){
                                                                                    anyErrors = true;
                                                                                }
                                                                            }else{
                                                                                anyErrors = true;
                                                                            }
                                                                        }
                                                                    }
                                                                }else{
                                                                    anyErrors = true;
                                                                }
                                                         
                                                            }else{
                                                                //check if all numbers, first:, last:, start, end, number/numer, range/number and ranges, or any commas separated combination
                                                                if(val.trim() !== ""){
                                                                    let parts = val.split(",");
                                                                    for(let i=0; i<parts.length; i++){
                                                                        let part = parts[i].trim();
                                                                        let match = part.match(/^((first:\s?\d+)|(last:\s?\d+)|(\d+)|(start)|(end)|(\d+\^\d+)|(\d+\.\.)|((((start)|(\d+))\.\.)?((end)|(\d+))(\^(\d+(\.\.((end)|(\d+)))?))?))$/ig)
                                                                        if(!match){
                                                                            anyErrors = true;
                                                                        }
                                                                        if(part.includes("^") && !part.includes("..")){
                                                                            let subParts = part.split("^");
                                                                            let num1, num2;
                                                                            if(subParts[0].includes("..") && subParts[1].includes("..")){
                                                                                let rangeParts = subParts[0].split("..");
                                                                                let rangeParts2 = subParts[1].split("..");
                                                                                num1 = rangeParts[1].trim().toLowerCase();
                                                                                num2 = rangeParts2[0].trim().toLowerCase();
                                                                            }else{
                                                                                num1 = subParts[0].trim().toLowerCase();
                                                                                num2 = subParts[1].trim().toLowerCase();
                                                                            }
                                                                        }


                                                                    }
                                                                }else{
                                                                    anyErrors = true;
                                                                }
                                                            }

                                                            if(anyErrors){
                                                                if(!formJson.layout.errorIdList.includes(pfx + "patternText"+index1)){
                                                                    formJson.layout.errorIdList.push(pfx + "patternText"+index1)
                                                                }
                                                            }else{
                                                                //remove id from error list
                                                                const indexE = formJson.layout.errorIdList.indexOf(pfx + "patternText"+index1);
                                                                if (indexE > -1) {
                                                                    formJson.layout.errorIdList.splice(indexE, 1);
                                                                }                            
                                                            }

                                                            setFormJson({...formJson});
                                                        }}
                                                        variant="outlined"
                                                        error={formJson.layout.errorIdList.includes(pfx + "patternText"+index1)}
                                                    />
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {pattern.type === "OC" &&
                                        <div style={{display: "flex"}}>
                                            <div style={{paddingTop: "0"}}>
                                                <div  style={{display: "flex", alignItems: "center"}}>
                                                     <div style={{width: "200px", paddingRight: "5px"}}>
                                                        <SelectBox
                                                            customClass={true}
                                                            className="modTypeWidth"
                                                            disabled={formJson.layout.isRedo === true}
                                                            margin="normal"
                                                            variant="outlined"
                                                            name="relationType"
                                                            id={"relationTypeoc"+index1}                                                     
                                                            key={"relationTypeoc"+index1}
                                                            value={mod.countType}
                                                            onChange={(e)=>{
                                                                mod.countType = e.target.value;
                                                                setFormJson({...formJson});
                                                            }}
                                                            items={occurrenceType}
                                                        />
                                                    </div>

                                                    <Tooltip title={"Only allows whole numbers"} placement="top" arrow disableFocusListener>
                                                    <div style={{width: "100px", marginBottom: "8px"}}>
                                                    <TextInput 
                                                        fullWidth
                                                        disabled={formJson.layout.isRedo === true}
                                                        spellCheck="false"
                                                        id={pfx + "patternTextoc"+index1}
                                                        key={"patternTextoc"+index1}
                                                        label={'number'}
                                                        value={mod.countStr}
                                                        onChange={(e)=>{
                                                            let val = e.target.value;
                                                            mod.countStr = val;
                                                            setFormJson({...formJson});

                                                            let anyErrors = false;

                                                            //val can be only numbers
                                                            if(!/^\d+$/.test(val.trim())){
                                                                anyErrors = true;
                                                            }

                                                            if(mod.type === "PERC"){
                                                                //value must be between 1 and 100
                                                                let perc = parseInt(val.trim());
                                                                if(perc < 1 || perc > 100){
                                                                    anyErrors = true;
                                                                }
                                                            }
                                                        
                                                            
                                                            mod.count = parseInt(val.trim());

                                                            if(anyErrors){
                                                                if(!formJson.layout.errorIdList.includes(pfx + "patternTextoc"+index1)){
                                                                    formJson.layout.errorIdList.push(pfx + "patternTextoc"+index1)
                                                                }
                                                            }else{
                                                                //remove id from error list
                                                                const indexE = formJson.layout.errorIdList.indexOf(pfx + "patternTextoc"+index1);
                                                                if (indexE > -1) {
                                                                    formJson.layout.errorIdList.splice(indexE, 1);
                                                                }                            
                                                            }
                                                        }}
                                                        variant="outlined"
                                                        error={formJson.layout.errorIdList.includes(pfx + "patternTextoc"+index1)}
                                                    />
                                                    </div>
                                                    </Tooltip>
                                                    <div style={{width: "220px", paddingRight: "10px", paddingLeft: "15px"}}>
                                                        <SelectBox
                                                            customClass={true}
                                                            className="modTypeWidth"
                                                            disabled={formJson.layout.isRedo === true}
                                                            margin="normal"
                                                            variant="outlined"
                                                            name="relationType"
                                                            id={"relationTypeoc"+index1}                                                     
                                                            key={"relationTypeoc"+index1}
                                                            value={mod.type}
                                                            onChange={(e)=>{
                                                                if(mod.count > 100){
                                                                    mod.count = 100;
                                                                    mod.countStr = "100";
                                                                }
                                                                mod.type = e.target.value;
                                                                setFormJson({...formJson});
                                                            }}
                                                            items={occurrenceMod}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                    <div style={{display: "flex", alignItems: "center", paddingBottom:"15px"}}>
                                        <div style={{paddingRight: "10px"}}>

                                        {pattern.cmCriteria.length > 1 &&
                                            <div 
                                                className="plus-min-button" // control-spacer custom-filter-label"
                                                onClick={()=>{
                                                    if(!formJson.layout.isRedo) {
                                                        pattern.cmCriteria.splice(index1, 1);
                                                        setFormJson({...formJson});
                                                    }
                                                }}
                                                style={{ width: "32px", height: "32px", margin: "5px 0 0 0", cursor: formJson.layout.isRedo ? "not-allowed" : "pointer", backgroundColor: toggle ? 'white' : '#292929', color: toggle ? '#777' : 'white'}}
                                            >
                                                <FaMinus/>
                                            </div>
                                        }
                                        </div>
                                        <div 
                                            className="plus-min-button" // control-spacer custom-filter-label"
                                            onClick={()=>{
                                                if(!formJson.layout.isRedo) {
                                                    let newModAtom = _.cloneDeep(modAtom);
                                                    switch(pattern.type){
                                                        case "OC":
                                                            newModAtom.count = 1;
                                                            newModAtom.countStr = "";
                                                            newModAtom.type = occurrenceMod[0].value;
                                                            newModAtom.countType = occurrenceType[1].value;
                                                            delete newModAtom.posList;
                                                            delete newModAtom.posListStr;
                                                            break;
                                                        case "FP":
                                                            newModAtom.type = positionsMod[0].value;
                                                            newModAtom.posList = [{region: "1"}];
                                                            break;
                                                        default:
                                                            newModAtom.type = positionsMod[0].value;
                                                            newModAtom.posList = [{start: "1"}];
                                                            break;
                                                    }
                                                    pattern.filterName = "";
                                                    pattern.cmCriteria.push(newModAtom);
                                                    setFormJson({...formJson});
                                                }
                                            }}
                                                style={{ width: "32px", height: "32px", margin: "5px 0 0 0", cursor: formJson.layout.isRedo ? "not-allowed" : "pointer", backgroundColor: toggle ? 'white' : '#292929', color: toggle ? '#777' : 'white'}}
                                        >
                                            <FaPlus />
                                        </div>
                                    </div>
                                </div>
                                
                                {(mod.modType === "SMOD" || mod.modType === "OSMOD") &&
                                <div style={{marginLeft: "-5px", paddingBottom: "15px"}}>
                                    <SelectedModification
                                        disabled={formJson.layout.isRedo}
                                        setModification={(codes) => {
                                            mod.codes = codes;
                                            if(codes == ""){
                                                if(!formJson.layout.errorIdList.includes(pfx + "modCodes"+index+"-"+index1)){
                                                    formJson.layout.errorIdList.push(pfx + "modCodes"+index+"-"+index1);
                                                }
                                            }else{
                                                  formJson.layout.errorIdList = formJson.layout.errorIdList.filter(id => id !== pfx + "modCodes"+index+"-"+index1);
                                            }
                                            setFormJson({...formJson});
                                        }}
                                        startCodes={mod.codes}
                                        type={formJson.searchInfo.qdb_seq_type}
                                        error={formJson.layout.errorIdList.includes(pfx + "modCodes"+index+"-"+index1) === true}
                                        availableModCodes={props.availableModCodes}
                                    />
                                </div>
                                }
                            </div>
                           
                        )
                    })}
                    </>
                    }
                </div>
                <div style={{width: "100%", display: "flex", justifyContent: "right", paddingTop: "10px"}}>
                    <div style={{paddingRight: "10px"}} >
                        <Button 
                            disabled={formJson.layout.isRedo === true}
                            className="accountInfo"  
                            onClick={()=>{
                                const criteriaCount = pattern.cmCriteria.length;
                                pattern.cmCriteria = [_.cloneDeep(modAtom)];

                                for(let i = 0; i < criteriaCount; i++){
                                    formJson.layout.errorIdList = formJson.layout.errorIdList.filter(id => id !== pfx + "patternText"+i);
                                    formJson.layout.errorIdList = formJson.layout.errorIdList.filter(id => id !== pfx + "patternTextoc"+i);
                                    formJson.layout.errorIdList = formJson.layout.errorIdList.filter(id => id !== pfx + "modCodes"+index+"-"+i);
                                }
                                formJson.layout.errorIdList = formJson.layout.errorIdList.filter(id => id !== pfx + "patternFP"+index);

                                if(pattern.type === "OC"){
                                    pattern.cmCriteria[0].count = 1;
                                    pattern.cmCriteria[0].countStr = "";
                                    pattern.cmCriteria[0].type = occurrenceMod[0].value;
                                    pattern.cmCriteria[0].countType = occurrenceType[1].value;
                                    delete pattern.cmCriteria[0].posList;
                                    delete pattern.cmCriteria[0].posListStr;
                                }
                                
                                pattern.filterName = "";
                                setFormJson({...formJson});
                            }}>
                            Clear
                        </Button>
                    </div>
                    {formJson.searchInfo[filtersKey].patterns.length > 1 &&
                    <div style={{paddingRight: "10px", marginTop: "4px"}}>
                        <Button 
                        variant="secondary" 
                        disabled={formJson.layout.isRedo === true}
                        onClick={() => {
                            formJson.searchInfo[filtersKey].patterns.splice(index, 1);
                            setFormJson({...formJson});
                        }}>Remove</Button>
                    </div>
                    }
                    <Button
                        disabled={formJson.layout.isRedo}
                        hidden={hideTemplates}
                        style={{ backgroundColor: '#0182C5',
                            borderColor: '#1F4E79',
                            border: '1px solid #1F4E79',
                            color: 'white',
                            margin: "4px",
                            textTransform: 'capitalize',
                            '&:hover': {
                                backgroundColor: '#0182C5',
                                boxShadow: 'none',
                            },}}
                            onClick={()=>{
                                setPatternIndex(index);
                                const currentFilterName = formJson.searchInfo[filtersKey].patterns[index].filterName || "";
                                if (currentFilterName) {
                                    let displayName = currentFilterName;
                                    if (displayName.startsWith("__")) {
                                        const parts = displayName.split("__");
                                        if (parts.length >= 3) displayName = parts[parts.length - 1];
                                    }
                                    openSaveUI("Pattern", displayName, true);
                                } else {
                                    openSaveUI("Pattern");
                                }
                            }}
                    >{formJson.searchInfo[filtersKey].patterns[index].filterName ? "Update pattern template" : "Save as new pattern"}</Button>
                </div>
            </div>
                 )
            })}
            <div style={{display: "flex", justifyContent: "space-between", paddingBottom: "5px"}}>
                <div style={{paddingLeft: "10px"}}>
                    <div
                    className="plus-min-button"
                    style={{ width: "32px", height: "32px", margin: "5px 0 0 0", cursor: formJson.layout.isRedo ? "not-allowed" : "pointer", backgroundColor: toggle ? 'white' : '#292929', color: toggle ? '#777' : 'white'}}

                    onClick={()=>{
                        if(!formJson.layout.isRedo) {
                            formJson.searchInfo[filtersKey].patterns.push(_.cloneDeep(patternAtom));
                            setFormJson({...formJson});
                        }
                    }}
                    >
                        <FaPlus />
                    </div>
                </div>
                <div style={{width: "100%"}}></div>
                <div style={{paddingRight: "10px"}} hidden={hideTemplates}>
                    <Button
                        disabled={formJson.layout.isRedo === true}
                        style={{ backgroundColor: '#0182C5',
                            borderColor: '#1F4E79',
                            border: '1px solid #1F4E79',
                            color: 'white',
                            margin: "4px",
                            width: "auto",
                            whiteSpace: "nowrap",
                            textTransform: 'capitalize',
                            '&:hover': {
                                backgroundColor: '#0182C5',
                                boxShadow: 'none',
                            },}}
                        
                        onClick={()=>{
                            const currentTemplateName = formJson.searchInfo[filtersKey].template_name || "";
                            if (currentTemplateName) {
                                openSaveUI("Search Pattern", currentTemplateName, true);
                            } else {
                                openSaveUI("Search Pattern");
                            }
                        }}

                    >{formJson.searchInfo[filtersKey].template_name ? "Update search pattern template" : "Save as new Search Pattern"}</Button>
                </div>
            </div>
            </div>
            </div>
        </div>
        }
            <GQPopup
                show={saveUI}
                close={()=>{closeSaveUI()}}
                innerHtml={
                    <div style={{width: "500px", padding: "10px", borderRadius: "4px"}}>
                        <div style={{paddingBottom: "5px"}}>
                            <span className="center historyPopupHeader tableCaption">{isUpdateMode ? "Update" : "New"} {templateType} Template</span>
                        </div>
                        <input
                            id="saveTemplateName"
                            onChange={(event)=>setTemplateName(event.target.value)}
                            value={templateName}
                            style={{width: "100%", padding: "8px", fontSize: "14px", boxSizing: "border-box", border: "1px solid #ccc", borderRadius: "4px", backgroundColor:toggle?'white':'#292929' , color: toggle ? 'black' : 'white'}}
                            type="text"
                            width={"100%"}
                            placeholder="Name your template"
                            autoComplete="off"
                            spellCheck="false"
                        />

                        <div style={{width: "100%", padding: "5px", display: "flex", justifyContent: "flex-end"}}>
                            <Button className={"submitButtonClass"} style={{marginRight: "10px"}} onClick={()=>{closeSaveUI();}}>Cancel</Button>
                            <Button className={"cancelButtonClass"} onClick={()=>{SaveTemplate();}}>{isUpdateMode ? (templateName.trim() === updateModeOriginalName ? "Update" : (doesTemplateNameExist() ? "Overwrite Existing template" : "Save as new")) : saveButtonLabel}</Button>
                        </div>
                    </div>
                }
            />

            <GQPopup
                show={confirmDeletePatternTemplateUI}
                close={() => { setConfirmDeletePatternTemplateUI(false); setActionSearchTemplateName(""); }}
                innerHtml={
                    <div style={{width: "400px", padding: "10px"}}>
                        <div style={{paddingBottom: "10px"}}>
                            <span className="center historyPopupHeader tableCaption">Delete Search Pattern Template</span>
                        </div>
                        <p>Are you sure you want to delete the template <strong>{actionSearchTemplateName}</strong>?</p>
                        <div style={{display: "flex", justifyContent: "flex-end", gap: "8px"}}>
                            <Button className={"submitButtonClass"} onClick={() => { setConfirmDeletePatternTemplateUI(false); setActionSearchTemplateName(""); }}>Cancel</Button>
                            <Button className={"cancelButtonClass"} onClick={handleDeletePatternTemplate}>Delete</Button>
                        </div>
                    </div>
                }
            />

            <GQPopup
                show={renamePatternTemplateUI}
                close={() => { setRenamePatternTemplateUI(false); setRenamePatternTemplateValue(""); setActionSearchTemplateName(""); }}
                innerHtml={
                    <div style={{width: "400px", padding: "10px"}}>
                        <div style={{paddingBottom: "10px"}}>
                            <span className="center historyPopupHeader tableCaption">Rename Search Pattern Template</span>
                        </div>
                        <input
                            onChange={(e) => setRenamePatternTemplateValue(e.target.value)}
                            value={renamePatternTemplateValue}
                            style={{width: "100%", padding: "8px", fontSize: "14px", boxSizing: "border-box", border: "1px solid #ccc", borderRadius: "4px", backgroundColor: toggle ? 'white' : '#292929', color: toggle ? 'black' : 'white'}}
                            type="text"
                            autoComplete="off"
                            spellCheck="false"
                            placeholder="New template name"
                        />
                        <div style={{display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "10px"}}>
                            <Button className={"submitButtonClass"} onClick={() => { setRenamePatternTemplateUI(false); setRenamePatternTemplateValue(""); setActionSearchTemplateName(""); }}>Cancel</Button>
                            <Button className={"cancelButtonClass"} onClick={handleRenamePatternTemplate}>Rename</Button>
                        </div>
                    </div>
                }
            />

            <GQPopup
                show={confirmDeletePatternUI}
                close={() => { setConfirmDeletePatternUI(false); setActionPatternIndex(-1); setActionPatternFilterName(""); }}
                innerHtml={
                    <div style={{width: "400px", padding: "10px"}}>
                        <div style={{paddingBottom: "10px"}}>
                            <span className="center historyPopupHeader tableCaption">Delete Pattern Template</span>
                        </div>
                        <p>Are you sure you want to delete the pattern template <strong>{actionPatternFilterName.startsWith("__") ? actionPatternFilterName.split("__").pop() : actionPatternFilterName}</strong>?</p>
                        <div style={{display: "flex", justifyContent: "flex-end", gap: "8px"}}>
                            <Button className={"submitButtonClass"} onClick={() => { setConfirmDeletePatternUI(false); setActionPatternIndex(-1); setActionPatternFilterName(""); }}>Cancel</Button>
                            <Button className={"cancelButtonClass"} onClick={handleDeletePattern}>Delete</Button>
                        </div>
                    </div>
                }
            />

            <GQPopup
                show={renamePatternUI}
                close={() => { setRenamePatternUI(false); setRenamePatternValue(""); setActionPatternIndex(-1); setActionPatternFilterName(""); }}
                innerHtml={
                    <div style={{width: "400px", padding: "10px"}}>
                        <div style={{paddingBottom: "10px"}}>
                            <span className="center historyPopupHeader tableCaption">Rename Pattern Template</span>
                        </div>
                        <input
                            onChange={(e) => setRenamePatternValue(e.target.value)}
                            value={renamePatternValue}
                            style={{width: "100%", padding: "8px", fontSize: "14px", boxSizing: "border-box", border: "1px solid #ccc", borderRadius: "4px", backgroundColor: toggle ? 'white' : '#292929', color: toggle ? 'black' : 'white'}}
                            type="text"
                            autoComplete="off"
                            spellCheck="false"
                            placeholder="New pattern name"
                        />
                        <div style={{display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "10px"}}>
                            <Button className={"submitButtonClass"} onClick={() => { setRenamePatternUI(false); setRenamePatternValue(""); setActionPatternIndex(-1); setActionPatternFilterName(""); }}>Cancel</Button>
                            <Button className={"cancelButtonClass"} onClick={handleRenamePattern}>Rename</Button>
                        </div>
                    </div>
                }
            />
        </>
    )
}

export default CMSearchPatterns